import { Dispatch, SetStateAction } from 'react';

import Link from 'next/link';

import { RedDivider } from '@components/views/landing/common/NavigationCard/NavigationCardStyles';
import OriginalPrice from '@components/ui/price/OriginalPrice';
import { Currencies } from '@constants/constants';
import { Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { ChevronRight } from '@assets/icons';
import MyFavoriteComponent from '@components/views/my-favorites/MyFavoriteComponent';
import {
  FavoriteItemType,
  WebUrlType,
  WishListItemViewModel,
  WishListViewModel,
} from '@api/v3';
import { useAuthState } from '@contexts/auth/AuthContext';
import { hotelMostPreferred } from '@utils/newDataLayer/productMostPreferred';

import {
  Content,
  StyledImage,
  TopInfo,
  TopInfoText,
  BottomInfo,
  BottomInfoContainer,
  PriceWrapper,
  Title,
  PriceLabel,
  ImageWrapper,
  FavoriteWrapper,
} from './styled';

export interface Props {
  index: number;
  title: string;
  price: number;
  currency?: string;
  image: {
    url: string;
    alt?: string;
  };
  hotel?: any;
  favoriteLists?: WishListViewModel[];
  refetchFavoriteLists?: any;
  defaultList?: WishListViewModel;
  defaultListItems?: WishListItemViewModel[];
  refetchDefaultList?: any;
  itemType?: WebUrlType;
  isRedirectingSet?: Dispatch<SetStateAction<boolean>>;
}

const PreferredHotelsItem = ({
  title,
  index,
  price,
  currency = Currencies.TL,
  image,
  hotel,
  favoriteLists,
  refetchFavoriteLists,
  defaultList,
  defaultListItems,
  refetchDefaultList,
  itemType,
  isRedirectingSet,
}: Props) => {
  const loginInfo = useAuthState();
  return (
    <Content>
      {itemType === WebUrlType.HOTEL ? (
        <FavoriteWrapper>
          <MyFavoriteComponent
            itemId={hotel?.id}
            itemName={hotel?.name}
            imageUrl={image?.url ?? ''}
            type={FavoriteItemType.HOTEL}
            isListing={true}
            itemUrl={hotel?.url.slice(1)}
            favoriteLists={favoriteLists}
            refetchFavoriteLists={refetchFavoriteLists}
            defaultList={defaultList}
            defaultListItems={defaultListItems}
            refetchDefaultList={refetchDefaultList}
            fontSize={24}
            fontColor={loginInfo.userInfo.id ? 'coral' : 'eclipse'}
            isHomePage={true}
          />
        </FavoriteWrapper>
      ) : null}

      <Link
        style={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          width: 'auto',
        }}
        href={hotel?.url}
        title={hotel?.name}
        prefetch={false}
        onClick={() => {
          isRedirectingSet?.(true);
          hotelMostPreferred([hotel], true);
        }}
      >
        <ImageWrapper>
          <StyledImage
            src={image?.url || ''}
            alt={image?.alt || hotel?.name}
            width={500}
            height={400}
          />
        </ImageWrapper>

        {index ? (
          <TopInfo>
            <TopInfoText>{index}</TopInfoText>
          </TopInfo>
        ) : null}
        <BottomInfoContainer>
          <BottomInfo>
            <Title>{title || ''}</Title>
            <RedDivider height={3} width={18} />
            {price ? (
              <Row alignItems='center' justifyContent='space-between'>
                <PriceWrapper>
                  <OriginalPrice
                    decimalShow={true}
                    price={price}
                    currency={currency}
                    noLine
                  />
                  <PriceLabel>’ den itibaren</PriceLabel>
                </PriceWrapper>

                <CustomIcon
                  icon={ChevronRight}
                  width={12}
                  height={16}
                  paletteColor='lightGray'
                />
              </Row>
            ) : null}
          </BottomInfo>
        </BottomInfoContainer>
      </Link>
    </Content>
  );
};

export default PreferredHotelsItem;
